import styles from "./UI.module.css";

// ── Button ───────────────────────────────────────────────────────────────────
export const Button = ({
  children, variant = "primary", size = "md",
  onClick, disabled, fullWidth, style = {}, type = "button",
}) => (
  <button
    type={type}
    onClick={onClick}
    disabled={disabled}
    className={[
      styles.btn,
      styles[`btn--${variant}`],
      styles[`btn--${size}`],
      fullWidth ? styles["btn--full"] : "",
    ].join(" ")}
    style={style}
  >
    {children}
  </button>
);

// ── Badge ────────────────────────────────────────────────────────────────────
export const Badge = ({ children, color = "accent" }) => (
  <span className={[styles.badge, styles[`badge--${color}`]].join(" ")}>
    {children}
  </span>
);

// ── StarRating ───────────────────────────────────────────────────────────────
export const StarRating = ({ rating, count }) => (
  <div className={styles.stars}>
    <span className={styles.starsIcons}>
      {[1,2,3,4,5].map((i) => (
        <span key={i} style={{ opacity: i <= Math.round(rating) ? 1 : 0.3 }}>★</span>
      ))}
    </span>
    <span className={styles.starsRating}>{rating}</span>
    {count !== undefined && (
      <span className={styles.starsCount}>({count.toLocaleString()})</span>
    )}
  </div>
);

// ── SectionTitle ─────────────────────────────────────────────────────────────
export const SectionTitle = ({ eyebrow, title, subtitle, center }) => (
  <div className={[styles.sectionTitle, center ? styles["sectionTitle--center"] : ""].join(" ")}>
    {eyebrow && <p className={styles.eyebrow}>{eyebrow}</p>}
    <h2 className={styles.title}>{title}</h2>
    {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
  </div>
);

// ── Spinner ──────────────────────────────────────────────────────────────────
export const Spinner = () => <div className={styles.spinner} />;

// ── Divider ──────────────────────────────────────────────────────────────────
export const Divider = () => <div className={styles.divider} />;

// ── Input ────────────────────────────────────────────────────────────────────
export const Input = ({ label, ...props }) => {
  const id = label ? label.toLowerCase().replace(/\s+/g, "-") : undefined;
  return (
    <label className={styles.inputWrap} htmlFor={id}>
      {label && <span className={styles.inputLabel}>{label}</span>}
      <input id={id} name={id} className={styles.input} {...props} />
    </label>
  );
};

// ── Select ───────────────────────────────────────────────────────────────────
export const Select = ({ label, options, ...props }) => (
  <label className={styles.inputWrap}>
    {label && <span className={styles.inputLabel}>{label}</span>}
    <select className={styles.select} {...props}>
      {options.map((o) => (
        <option key={o.value} value={o.value}>{o.label}</option>
      ))}
    </select>
  </label>
);

// ── Textarea ─────────────────────────────────────────────────────────────────
export const Textarea = ({ label, ...props }) => (
  <label className={styles.inputWrap}>
    {label && <span className={styles.inputLabel}>{label}</span>}
    <textarea className={styles.textarea} {...props} />
  </label>
);

// ── Modal ────────────────────────────────────────────────────────────────────
export const Modal = ({ open, onClose, children }) => {
  if (!open) return null;
  return (
    <div className={styles.modalBackdrop} onClick={onClose}>
      <div className={styles.modalBox} onClick={(e) => e.stopPropagation()}>
        <button className={styles.modalClose} onClick={onClose}>✕</button>
        {children}
      </div>
    </div>
  );
};
